
  import { Component, Prop, Watch } from 'vue-property-decorator'
  import { GForm } from '@/components/forms/GForm'
  import { removeAccents } from '@/utils/general'
  import { Generation } from '@/entities/vehicle'
  import { plainToInstance } from 'class-transformer'
  import { Debounce } from '@/utils/decorators'

@Component({
  components: { },
})
  export default class ImportAttribute extends GForm {
  @Prop({ type: Object, default: () => null }) value:any

  disabled=true
  generations: Generation[] = []
  selected = null

  @Watch('value', { immediate: true, deep: true })
  async onValueChange (newVal: any) {
    if (!newVal?.version?.match?.id || !newVal?.checkAttributes) return
    this.generations = []
    newVal.checkAttributes = false
    const generation = await this.fetchData({
      query: { name: 'findLite', model: 'Generation' },
      filter: {
        id_version_year: { _eq: newVal.version.match.id },
      },
    })
    this.generations = generation?.map((item, index) => {
        item.sku = `Opción ${index + 1}`
        return item
      })
    if (generation?.length > 1) {
      const generationMatch = generation.find((item: any) => {
        let match = true

        const newValTraction = newVal?.traction?.val?.length
          ? newVal?.traction?.val
          : newVal?.traction?.value?.length
            ? newVal?.traction?.value
            : null

        const newValFuel = newVal?.fuel?.val?.length
          ? newVal?.fuel?.val
          : newVal?.fuel?.value?.length
            ? newVal?.fuel?.value
            : null

        const newValTransmission = newVal?.transmission?.val?.length
          ? newVal?.transmission?.val
          : newVal?.transmission?.value?.length
            ? newVal?.transmission?.value
            : null

        if (item.traction.val?.length && removeAccents(item.traction.val?.toLowerCase()) !== removeAccents(newValTraction?.toLowerCase())) {
          match = false
        }

        if (item.fuel.val?.length && removeAccents(item.fuel.val?.toLowerCase()) !== removeAccents(newValFuel?.toLowerCase())) {
          match = false
        }

        if (item.transmission.val?.length && removeAccents(item.transmission.val?.toLowerCase()) !== removeAccents(newValTransmission?.toLowerCase())) {
          match = false
        }

        return match
      })

      if (generationMatch?.id) {
        this.setGenerationValues(generationMatch)
      }

      this.disabled = false
    } else if (generation?.length === 1) {
      this.setGenerationValues(generation[0])
      this.generations = generation
    } else {
      const attributes = await this.fetchData({
        query: {
          name: 'find',
          model: 'Attribute',
        },
        filter: {
          _and: [
            { id_version_year: { _eq: newVal.version.match.id } },
            { component: { slug: { _in: ['fuel', 'transmission', 'traction'] } } },
          ],
        },
      })

      newVal.traction.value = attributes.find((item: any) => item.slug === 'traction')?.val
      newVal.fuel.value = attributes.find((item: any) => item.slug === 'fuel')?.val
      newVal.transmission.value = attributes.find((item: any) => item.slug === 'transmission')?.val

      const customGeneration = plainToInstance(Generation, {
        id: null,
        sku: 'Opción 1',
        traction: newVal.traction,
        fuel: newVal.fuel,
        transmission: newVal.transmission,
      })
      this.generations = [customGeneration]
      this.selected = customGeneration
      this.value.generation = customGeneration
      this.emitValue()
    }
    this.emitValue()
  }

  setGenerationValues (generation) {
      if (generation?.traction?.val) {
        this.value.traction.value = generation.traction.val
      }

      if (generation?.fuel?.val) {
        this.value.fuel.value = generation.fuel.val
      }

      if (generation?.transmission?.val) {
        this.value.transmission.value = generation.transmission.val
      }

      this.value.generation = generation
      this.selected = generation
      this.emitValue()
  }

  onAttributesChange (selected) {
    if (!selected) return

    this.setGenerationValues(selected)
  }

  @Debounce(500)
  emitValue () {
    this.$emit('input', this.value)
  }
  }
